import { TeamOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import React from "react";
import { LastUpdated } from "~/components/atom/LastUpdated.jsx";
import { ECETLazy } from "~/components/topmeteo/ECETLazy.jsx";
import { clubHasFlight } from "~/featureMatrix.jsx";
import { $t } from "~/i18n.js";

export const DayInfo = ({ activeDay, profile, club }) => (
  <div className="column" style={{ marginTop: 6, alignItems: "flex-start" }}>
    {!activeDay.gaat_door && (
      <Tag style={{ marginRight: 6 }} color="red">
        {$t("Geannuleerd")}
      </Tag>
    )}
    <p className="title">
      {activeDay.type_dag ? (
        <span>{activeDay.type_dag}</span>
      ) : (
        <span>
          {$t("Dag")}: {$t("Automatisch aangemaakt")}
        </span>
      )}
      {activeDay.titel && activeDay.titel.length > 0 && ": " + activeDay.titel}
      {!activeDay.is_vliegend && clubHasFlight() && (
        <span style={{ marginLeft: 12 }}>
          <TeamOutlined /> {$t("Niet vliegend")}
        </span>
      )}

      {profile.wijzig_financial &&
        activeDay.status === "open" &&
        activeDay.gaat_door &&
        !activeDay.accept_vouchers && (
          <Tag style={{ marginLeft: 6 }}>{$t("Geen bonnen")}</Tag>
        )}
    </p>
    <p className="row" style={{ gap: 6 }}>
      {activeDay.gaat_door && (
        <span>
          {$t("briefing om")} {activeDay.briefing_tijd || "??"},{" "}
          {activeDay.vertrek_vliegveld}
        </span>
      )}

      {club.vliegveld_icao === activeDay.vertrek_vliegveld && (
        <ECETLazy
          date={activeDay.datum}
          longitude={club.vliegveld_lon}
          latitude={club.vliegveld_lat}
          country={club.country}
        />
      )}
    </p>
    {activeDay.updated_name && activeDay.updated_date && (
      <LastUpdated
        date_updated={activeDay.updated_date}
        updated_by={activeDay.updated_name}
      />
    )}
  </div>
);
